// material-ui
import { useTheme } from '@mui/material/styles';

import logoDark from 'assets/images/logo-dark.svg';
import logo from 'assets/images/logo.svg';

// ==============================|| LOGO SVG ||============================== //
interface LogoProps {
  isLarge?: boolean;
}

const Logo = ({ isLarge }: LogoProps) => {
  const theme = useTheme();
  const width = isLarge ? 255 : 170;
  const height = isLarge ? 46 : 31;

  return (
    <img
      src={theme.palette.mode === 'dark' ? logoDark : logo}
      alt='InoHub Energy'
      width={width}
      height={height}
    />
  );
};

export default Logo;
